import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useRequestData } from '../../Utilities/hooks'
import { GET_APP_SETTING_BY_NAME } from '../../requests'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import LeftArrowIcon from '@tecuity/sos-icons/react/left-arrow'
import { useHistory } from 'react-router'

const RecordDetailPageBackButton = () => {
  const history = useHistory()
  const isSidebarCollapsed = useSelector((state) => state.app.sidebarCollapsed, shallowEqual)
  const showRecordDetailPageBackButton = useRequestData(
    (cb) => {
      GET_APP_SETTING_BY_NAME('ShowRecordDetailPageBackButton', (setting) => {
        if (setting && setting.VALUE && setting.VALUE.toLowerCase() === 'true') cb(true)
      })
    },
    [],
    false
  )

  if (showRecordDetailPageBackButton)
    return (
      <React.Fragment>
        <br />
        <br />
        <br />
        <div className={`context-bar-wrapper ${isSidebarCollapsed ? 'sidebar-collapsed ' : ' '}`}>
          <ContextBar className="granite-context-bar">
            <ContextButton
              leftIcon={
                <div className="checkmark-wrapper left">
                  <LeftArrowIcon />
                </div>
              }
              onClick={() => history.goBack()}
              variant="secondary"
            >
              Back
            </ContextButton>
          </ContextBar>
        </div>
      </React.Fragment>
    )
  else return null
}

export default RecordDetailPageBackButton
